var parent = require('../../actual/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/object/keys.js
// module id = 3511
// module chunks = 25